import _ from "lodash";

const RightsMapping = [
  {
    required: "admin.*",
    config: [
      "page.nutzer",
      "page.antrag",
      "edit.antrag",
      "new.antrag",
      "new.hilfe",
      "edit.hilfe",
    ],
  },
  {
    required: "antrag.view",
    config: [
      "page.antrag",
      "edit.antrag",
      "new.antrag",
    ],
  },
  {
    required: "eigeneperson.create",
    config: [
      "page.person",
      "edit.person",
    ],
  },
  {
    required: "massnahme.view",
    config: [
      "page.massnahme",
      "edit.massnahme",
    ],
  },
  {
    required: "massnahme.create",
    config: [
      "new.massnahme",
    ],
  },
];

export function getUserUiconfig(user) {
  let items = ["page.profil", "page.hilfe"];

  RightsMapping.forEach(({ required, config, association }) => {
    const f = user.funktionen[required];
    if (f) {
      if (_.isUndefined(association) || ((association === "unspecific") !== f.specific)) {
        items = items.concat(config);
      }
    }
  });

  return _.fromPairs(_.map(items, re => [re, true]));
}
